import { render, staticRenderFns } from "./PopupUpgradeAccount.vue?vue&type=template&id=1b9bcc42&scoped=true"
import script from "./PopupUpgradeAccount.vue?vue&type=script&lang=js"
export * from "./PopupUpgradeAccount.vue?vue&type=script&lang=js"
import style0 from "./PopupUpgradeAccount.vue?vue&type=style&index=0&id=1b9bcc42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bcc42",
  null
  
)

export default component.exports